<app-programtitle title="Driving license eligiblity"></app-programtitle>
<p> Write a program to find out driving license eligiblity. If the applicant is aged above 17 then he/she is eligible to drive.</p>
<app-editor code="{{program}}"> </app-editor>